module.exports = __webpack_public_path__ + "static/img/google_auth.d7024e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/google_auth.png
// module id = +ZN9
// module chunks = 1